export default "/images/Eastridge.png?ccc59d45a13de154ed5059a6386f8cde";